import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { Select } from '@ngxs/store';
import { SidenavService } from 'app/library/grow/services/sidenav.service';
import { TeamTree } from 'app/library/team/models/team-tree.model';
import { Team } from 'app/library/team/models/team.model';
import { TeamsState } from 'app/library/team/models/teams.state';
import { TeamService } from 'app/library/team/services/team.service';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-teams-search',
    templateUrl: './teams-search.component.html',
    styleUrls: ['./teams-search.component.scss'],
})
export class TeamsSearchComponent extends UnsubscribeOnDestroy implements OnInit {
    @Select(TeamsState.getTotalCount)
    teamsTotalCount$: Observable<number>;

    @ViewChild(MatPaginator)
    paginator: MatPaginator;

    teamsTree: TeamTree[] = [];
    searchInput = new FormControl();
    isLoading = false;
    searchTerm: string;
    currentPage = 1;

    constructor(private _teamService: TeamService, private _router: Router, private _sidenavService: SidenavService) {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.searchInput.valueChanges.pipe(takeUntil(this._unsubscribeAll), debounceTime(300), distinctUntilChanged()).subscribe(async (searchTerm) => {
            const trimmedSearchTerm = (searchTerm || '').trim();

            this.searchTerm = trimmedSearchTerm;
            sessionStorage.setItem('searchTeams', trimmedSearchTerm);

            if (trimmedSearchTerm) {
                this.loadTeams();
            } else {
                this.teamsTree = [];
            }
        });

        setTimeout(() => {
            this.paginator.page.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
                this.loadTeams(false);
            });
        });
    }

    ngAfterContentInit(): void {
        const searchValue = sessionStorage.getItem('searchTeam');
        if (searchValue) {
            this.searchInput.setValue(searchValue);
        }
    }

    async loadTeams(resetPageIndex = false): Promise<void> {
        this.isLoading = true;

        if (resetPageIndex) {
            this.paginator.pageIndex = 0;
        }

        this.teamsTree = await this._teamService.searchTeams(this.searchTerm, this.paginator.pageSize, this.paginator.pageIndex + 1);
        this.isLoading = false;
    }

    navigateToTeamPage(team: Team): void {
        this._sidenavService.pageName = 'TEAMS.TITLE.PLURAL';

        if (this._sidenavService.isSidenavExpandable && this._sidenavService.sidenav && !this._sidenavService.sidenav.opened) {
            this._sidenavService.open();
        }

        this._router.navigateByUrl(`admin/people-development/teams/edit/${team.id}`);
    }
}
